import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../data/translations';
import About from '../components/About';
import Vision from '../components/Vision';
import Values from '../components/Values';
import Objectives from '../components/Objectives';
import './AboutPage.css';

const AboutPage = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <div className="about-page">
      <div className="page-hero">
        <div className="container">
          <div className="page-hero-content">
            <h1 className="page-title">{t.about}</h1>
            <p className="page-subtitle">
              {language === 'ar' 
                ? 'تعرف على منظمة مندولا للإغاثة والإعمار'
                : 'Learn about Mandola Relief & Reconstruction Organization'}
            </p>
          </div>
        </div>
      </div>
      
      <About />
      <Vision />
      <Values />
      <Objectives />
    </div>
  );
};

export default AboutPage;
